/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
import { getQuery, isVBAWorkflow, isIframe } from '@util'
import clientApi from '@plus/client-connect'

const clientName = clientApi.getCurrentClient()


export const isWPSClient = function () {
  if (typeof cefQuery != 'undefined' || typeof wpsQuery != 'undefined') {
    return true
  } else {
    return false
  }
}



export const listenerLogin = (logincb) => {
  clientApi.addListener({ clientName, data:{
    listenerNames: ['event.account.login'], 
    cb: logincb, // 回调
    listenerMode: 'COMMON'
  }})
}

export const listenerLogout = (logoutcb) => {
  clientApi.addListener({ clientName, data:{
    listenerNames: ['event.account.logout'], 
    cb: logoutcb, // 回调
    listenerMode: 'COMMON'
  }})
}

export const registerLogin = function (logincb, logoutcb) {
  // VBA情况下不注册监听用户的登录和注销
  if (isVBAWorkflow()) return

  listenerLogin(logincb)
  listenerLogout(logoutcb)
}

export const removeRegisterLogin = function () {
  // VBA情况下不清除监听用户的登录和注销
  if (isVBAWorkflow()) return

  clientApi.removeListener({ clientName, data:{
    listenerNames: ['event.account.login', 'event.account.logout', 'event.account.switchaccountfinished']
  }})
  
}

export const callLogin = function (cb) {
  clientApi.login({ clientName, cb})
}

/**
 * 关闭弹窗
 */
export const closeDialog = cb => {
  clientApi.callCommonApi({ clientName, eventName: 'common.webview.close', data: {
    params: {}, cb
  }})
}

/**
 * win 关闭tab
 */
export const closeWindow = () => {
  clientApi.callCommonApi({
    clientName, eventName: 'closeWindow', data: {}
  })
}
/**
 * 通知客户端创建成功
 * @param {*} companyId
 * @param {*} companyName
 * @param {*} cb
 */
export const createCompanySuccess = (companyId, companyName, cb) => {
  clientApi.callCommonApi({ 
    clientName, 
    eventName: 'onCreateCompanySuccess', 
    data: {
      params: {
        companyId,
        companyName,
      },
      cb
    }
  })
}

/**
 * 查看是否存在api
 * @param {*} apiName
 * @param {*} cb
 */
export const checkApiSupport = (apiName, cb) => {
  clientApi.callCommonApi({ 
    clientName, 
    eventName: 'common.util.support', 
    data: [apiName, cb]
  })
}

/**
 *  跳转到企业首页
 * @param {*} apiName
 * @param {*} cb
 */
export const sendCommand = (cmd, cb = '') => {
  clientApi.callCommonApi({ 
    clientName, 
    eventName: 'sendCommand', 
    data: {
      params: {
        cmd,
      },
      cb
    }
  })
}
/**
 * 刷新企业列表
 * @param {*} cb
 */
export const refreshCompanyList = cb => {
  checkApiSupport('refreshCompanyList', data => {
    if (data) {
      clientApi.callCommonApi({ 
        clientName, 
        eventName: 'refreshCompanyList', 
        data: {
          params: {},
          cb
        }
      })
    } else {
      // 兼容新标签页更新企业列表
      clientApi.callCommonApi({ 
        clientName, 
        eventName: 'common.util.openUrl', 
        data: {
            params: {
              url: 'ksoqing:////type=refreshcompanylist',
            },
          cb
        }
      })
    }
  })
}

/**
 * vba应用刷新企业列表
 * @param {*} cb
 */
 export const refreshVbaCompanyList = cb => {
    clientApi.callCommonApi({ 
      clientName, 
      eventName: 'vbapaycomponent.refreshCompanyList', 
      data: {
        params: {},
        cb
      }
    })
}

// 获取app信息
export const getAppInfo = cb => {
  return clientApi.getAppVersion({ clientName })
}

export const listenerSdkLogin = (logincb) => {
  // 备注：event.accountsdk.login 只有23年3月份包才有的API，故此需要兼容
  let isExecuted = false
  const fn = (...params) => {
    if (isExecuted) return
    isExecuted = true
    logincb(...params)
  }
  listenerLogin(fn)
  clientApi.addListener({ clientName, data:{
    listenerNames: ['event.accountsdk.login'], 
    cb: fn, // 回调
    listenerMode: 'COMMON'
  }})
}

export const listenerSdkLogout = (logoutcb) => {
  // 备注：event.accountsdk.logout 只有23年3月份包才有的API，故此需要兼容
  let isExecuted = false
  const fn = (...params) => {
    if (isExecuted) return
    isExecuted = true
    logoutcb(...params)
  }
  listenerLogout(fn)
  clientApi.addListener({ clientName, data:{
    listenerNames: ['event.accountsdk.logout'], 
    cb: fn, // 回调
    listenerMode: 'COMMON'
  }})
}

/**
 * @desc 获取是否教育版,备注，有202507统一版和旧版区分
 * @doc https://365.kdocs.cn/l/cclrpzhChfMj?from=koa&R=L1MvMg==
 * */
export const getIsTeach = async () => {
  const cb = data => {
    if (data) {
      try {
        const { status } = JSON.parse(data)
        return status
      } catch (e) {
        return false
      }
    }
  }

  return new Promise(resolve => {
    getOemSupported({ key: 'OemJsonFormat' }, data => {
      const status = cb(data)
      const key = status ? 'FrontPageForWPS365Edu' : 'EducationVersion'
      getOemSupported({ key }, res => {
        const result = cb(res)
        resolve(result)
      })
    })
    setTimeout(() => {
      resolve(false)
    }, 3000)
  })
}

/**
 * 检查是否支持客户端接口某项功能功能
 * @param feature 参数举例：{"feature":"jumpToCloudLocation"}，feature为需要检查的功能名称
 * 返回：{"support":"true", "callstatus":"ok"} support:true支持，false不支持，接口调不通也是不支持
 */
export const checkCloudFeatureSupport = (feature, cb) => {
  clientApi.callCommonApi({ 
    clientName, 
    eventName: 'common.wpscloud.checkCloudFeatureSupport',
    data: {
      params: {feature},
      cb
    }
  })
}

//vba url
export const openTagByVbaPay = (params) => {
  clientApi.callCommonApi({ 
    clientName, 
    eventName: 'common.payment.openTagByVbaPay',
    data: {
      params
    }
  })
}

// 获取oem容器是否支持
export const getOemSupported = (params, cb) => {
  clientApi.callCommonApi({
    clientName, 
    eventName: 'getOemSupported', 
    data: {
      params,
      cb
    }
  })
}

//vba send common
export const vbaSendCommand = (cmd, cb) => {
  clientApi.callCommonApi({
    clientName, 
    eventName: 'vbapaycomponent.sendCommand', 
    data: {
      params: {
        cmd,
      },
      cb
    }
  })
}

// 关闭当前tab
export const closeWebView = (params, cb) => {
  clientApi.callCommonApi({
    clientName, 
    eventName: 'close', 
    data: {
      params,
      cb
    }
  })
}

// 通知加载完成
export const onComponentLoaded = () => {
  clientApi.callCommonApi({
    clientName, 
    eventName: 'onComponentLoaded',
  })
}

// 添加容器
export const addDragArea = (params, cb) => {
  clientApi.callCommonApi({
    clientName, 
    eventName: 'common.webview.addDragArea',
    data: {
      params,
      cb
    }
  })
}

// 通知创建企业更新
export const updateRegistry = () => {
  clientApi.callCommonApi({
    clientName, 
    eventName: 'vbapaycomponent.updateRegistry'
  })
}